































import { Component, Mixins, Prop } from "vue-property-decorator";
import { Point, Size, Vector } from "../../../../../../base/domain/drawing";
import { StandardKeyboardHandler } from "../../../../../../base/components/system/keyboard";
import { PdfStyleDrawableMixin } from "../../../../../../base/components/system/mixins";
import { instanceOfIRectangleCoordinateEditable, instanceOfIVectorCoordinateEditable } from "../../../../../domain/editableFormat/properties";
import { CommonComponentsAccessibleMixin } from "../../mixins";
import { default as FormatPageObjectsSelector } from "./FormatPageObjectsSelector.vue";
import { FormatPageMouseTrackableMixin, ObjectUpdatesPromptableMixin } from "./mixins";

@Component({
  components: {
    StandardKeyboardHandler,
    FormatPageObjectsSelector,
  }
})
export default class FormatPageInputTracker extends Mixins(FormatPageMouseTrackableMixin, ObjectUpdatesPromptableMixin, CommonComponentsAccessibleMixin, PdfStyleDrawableMixin) {
  @Prop()
  isActive: boolean;

  @Prop({ default: () => new Size(10, 10) })
  gridSize: Size;

  get trackerSizeStyleProperties() {
    const image = this.image;
    if (!image) {
      return null;
    }
    return {
      width: image.size.width + "px",
      height: (image.size.height + 50) + "px"
    };
  }

  get scaledStyleProperties() {
    // transform scaleを指定するとelement-uiのel-dialogのモーダル表示がおかしくなってしまう
    // modalAppendToBody="false"を指定するとモーダル表示は正しくなるが、文書編集画面のscrollに依存する表示になってしまう
    // appendToBody="true"を指定すると概ね良さそうな表示になる。親から引き継がれていたcss指定が無くなるのでそこだけ注意が必要
    return {
      transform: "scale(" + this.scale + ", " + this.scale + ")",
      transformOrigin: "left top",
    };
  }

  $refs!: {
    focusTarget: HTMLElement,
    selector: FormatPageObjectsSelector,
  };

  isFocus: boolean = false;

  handleMouseDowned(event: PointerEvent): void {
    // オブジェクトが拾ってない場合だけここに来る.
    this.promptForObjectUpdates(event);
    if (this.pageElement) {
      this.$refs.selector.select(event);
    }
    this.$nextTick(() => this.deselectAllObjects());
  }

  handleMouseUpped(event: PointerEvent): void {
    // selectorが表示される前にマウスリリースされた場合だけここに来る.(はず...)
    this.$refs.selector.cancel();
  }

  handleMoving(offset: Size): boolean {
    if (!this.hasSelectedObjects) {
      return false;
    }
    this.$logger.debug("moving!(" + offset.width + "," + offset.height + ")");
    this.writePropertyWhenValid(s => s.setOffsets({
      source: this.selectedObjects[0],
      relocatingOffset: Point.to(offset.toPoint()),
      transformingRatesFromCenter: {
        x: 1,
        y: 1,
        width: 1,
        height: 1,
      },
    }));
    return true;
  }

  handleMoved(offset: Size): boolean {
    if (!this.hasSelectedObjects) {
      return false;
    }
    this.$logger.debug("moved!(" + offset.width + "," + offset.height + ")");
    const moveOffset = offset.toPoint();
    this.writePropertyWhenValid(s => {
      for (const object of this.selectedObjects) {
        const clone = object.clone();
        if (instanceOfIRectangleCoordinateEditable(clone)) {
          clone.location().setValue(Point.to(Point.from(clone.location().getValue()).add(moveOffset)));
        } else if (instanceOfIVectorCoordinateEditable(clone)) {
          clone.vector().setValue(Vector.to(Vector.from(clone.vector().getValue()).move(moveOffset)));
        }
        s.updateObject(clone);
      }
      s.setOffsets();
    });
    return true;
  }

  handleAllSelected(): boolean {
    this.selectAllObjects();
    return true;
  }

  handleDeleted(): boolean {
    this.getCommonComponents().getObjectsRemover().confirmAndRemove();
    return true;
  }

  handleUndone(): boolean {
    this.getCommonComponents().undo();
    return true;
  }

  handleRedone(): boolean {
    this.getCommonComponents().redo();
    return true;
  }

  handleCopied(): boolean {
    this.getCommonComponents().getClipboardManager().clipSelectedObjects();
    return true;
  }

  handlePasted(): boolean {
    this.getCommonComponents().getClipboardManager().pasteObjects();
    return true;
  }

  resetFocus(): void {
    // タブの移動で編集画面の外に出る場合にフォーカスを戻す.(編集画面外にフォーカスが移動して迷子になるのを防ぐ.)
    this.$doWhenValid(t => t.focus(), this.$refs.focusTarget);
  }
}
